import { useEffect } from "react";

const APP_HOME_URL =
  process.env.REACT_APP_APP_HOME_URL || "https://app.pedagogue.io";

const buildOtpRedirectUrl = () => {
  const query = new URLSearchParams(window.location.search);
  const email = query.get("email");

  if (email) {
    const verifyUrl = new URL("/auth/verify", APP_HOME_URL);
    verifyUrl.searchParams.set("email", email.trim().toLowerCase());
    verifyUrl.searchParams.set("return_to", window.location.origin);
    return verifyUrl.toString();
  }

  return new URL("/login", APP_HOME_URL).toString();
};

export const useResetPasswordHook = () => {
  useEffect(() => {
    window.location.replace(buildOtpRedirectUrl());
  }, []);

  const handleNavigateToLogin = () => {
    window.location.href = new URL("/login", APP_HOME_URL).toString();
  };

  return {
    password: "",
    confirmPassword: "",
    initializing: true,
    loading: false,
    error: "",
    success: false,
    sessionReady: false,
    handlePasswordChange: () => undefined,
    handleConfirmPasswordChange: () => undefined,
    handleSubmit: async () => undefined,
    handleNavigateToLogin,
  };
};
